// extracted by mini-css-extract-plugin
module.exports = {"visits-fair-container":"_2_fqGtqBvckpX_e8JUhlid"};